import React from 'react';
import { IndexSignalsV2 } from '../indices/IndexSignalsV2';

const FUTURES_SYMBOLS = [
  { value: 'ES', label: 'ES (E-mini S&P)' },
  { value: 'MES', label: 'MES (Micro E-mini)' },
  { value: 'NQ', label: 'NQ (E-mini Nasdaq-100)' },
  { value: 'MNQ', label: 'MNQ (Micro Nasdaq)' },
  { value: 'GC', label: 'GC (Gold)' },
  { value: 'CL', label: 'CL (Crude Oil)' },
];

export const FuturesSignalsV2: React.FC = () => (
  <IndexSignalsV2
    symbols={FUTURES_SYMBOLS}
    title="Futures Options Put Selling — V2 Time Horizons"
    defaultSymbol="ES"
  />
);
